// extracted by mini-css-extract-plugin
export default {"restoreLink":"ProjectItemSectionFieldList-module__restoreLink__RpT9tuU"};